// extracted by mini-css-extract-plugin
export default {"itemName":"_7PdQGk4CneBVTDn1PtD"};